import "@/common/mockPageContextInfo";
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { createPinia } from "pinia";
import { createVfm } from "vue-final-modal";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import Vue3Toastify, { type ToastContainerOptions } from "vue3-toastify";

import "vue3-toastify/dist/index.css";

import {
    faHome,
    faHouse,
    faInfoCircle,
    faCircleInfo,
    faPencilAlt,
    faPlus,
    faEdit,
    faInfo,
    faQuestionCircle,
    faCircleQuestion,
    faToriiGate,
    faCircleExclamation,
    faChevronRight,
    faChevronDown,
    faRotateLeft,
    faXmark,
    faGear,
    faThumbsUp,
    faClipboardList,
    faMoon,
    faSun,
    faUser,
    faAdjust,
    faEye,
    faArrowLeft,
    faSave,
    faTimes,
    faCircle,
    faSitemap,
    faChartLine,
    faSearch,
    faChartArea,
    faChartBar,
    faListAlt,
    faUsersCog,
    faEnvelope,
    faCalendarAlt,
    faLock,
    faListUl,
    faFileUpload,
    faTable,
} from "@fortawesome/free-solid-svg-icons";

library.add(
    faHome,
    faHouse,
    faInfoCircle,
    faCircleInfo,
    faPencilAlt,
    faPlus,
    faEdit,
    faInfo,
    faQuestionCircle,
    faCircleQuestion,
    faToriiGate,
    faCircleExclamation,
    faChevronRight,
    faChevronDown,
    faRotateLeft,
    faXmark,
    faGear,
    faThumbsUp,
    faClipboardList,
    faMoon,
    faSun,
    faUser,
    faAdjust,
    faEye,
    faArrowLeft,
    faSave,
    faTimes,
    faCircle,
    faSitemap,
    faChartLine,
    faSearch,
    faChartArea,
    faChartBar,
    faListAlt,
    faUsersCog,
    faEnvelope,
    faCalendarAlt,
    faLock,
    faListUl,
    faFileUpload,
    faTable
);
const vfm = createVfm();

const app = createApp(App);
app.config.globalProperties.$msalInstance = {};

app.use(createPinia())
    .use(vfm)
    .use(router)
    .use(Vue3Toastify, {
        autoClose: false,
        position: "top-center",
        duration: 5000,
    } as ToastContainerOptions)
    .component("font-awesome-icon", FontAwesomeIcon)
    .mount("#app");
